import {Component, OnInit, Input, ChangeDetectorRef, HostListener, OnDestroy} from '@angular/core';
import { BHQrCodeSiteScannerModel } from '../bh-qrcode-site-scanner.model';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { Model_WorkflowComponent } from 'src/app/app.models';
import { WorkflowComponentsService } from '../../../workflow-components.service';

@Component({
    selector: 'abw-bh-qrcode-site-scanner-design',
    templateUrl: './bh-qrcode-site-scanner-design.component.html',
    styleUrls: ['./bh-qrcode-site-scanner-design.component.scss']
})
export class BHQrCodeSiteScannerDesignComponent implements OnInit, OnDestroy {
    isComponentSelected = false;
	@Input() model: BHQrCodeSiteScannerModel;
    @Input() value: any;
    onComplete = new Subject();

    constructor(
        private _workflowComponentsService: WorkflowComponentsService,
        private _cdf: ChangeDetectorRef
    ) {
    }

    ngOnInit() {
        this._workflowComponentsService.workflowDesignerComponentSelected$.pipe(takeUntil(this.onComplete)).subscribe(_selectedComponent => {
            this.isComponentSelected = _selectedComponent != null && _selectedComponent.GUID == this.model.additional.GUID;
            this._cdf.detectChanges();
        });
    }

    @HostListener("click") onClick(){
        const base_component = this.model.additional as Model_WorkflowComponent;
        base_component.PROPERTIES = this.value;
        this._workflowComponentsService.workflowDesignerComponentSelected$.next(base_component);
    }

    ngOnDestroy() {
        this.onComplete.next();
        this.onComplete.complete();
    }
}